import { EmployeeDirectory } from "@/components/EmployeeDirectory";

const EmployeeDirectoryPage = () => {
  return (
    <div className="container mx-auto px-2 sm:px-4 py-4 sm:py-8">
      <EmployeeDirectory />
    </div>
  );
};

export default EmployeeDirectoryPage;
